import { Role } from './features/authentication';

// URL used for initiating authorization request
export const authorityUrl: string = `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/`;
export const redirectUri: string = process.env.REACT_APP_REDIRECT_URL ?? '';

// End point URL for Power BI API
export const powerBiApiUrl: string = 'https://api.powerbi.com/';

// Scope for securing access token
export const scopeBase: string[] = ['https://analysis.windows.net/powerbi/api/Report.Read.All'];

// Client Id (Application Id) of the AAD app.
export const clientId: string = process.env.REACT_APP_CLIENT_ID ?? '';

// Id of the workspace where the report is hosted
export const workspaceId: string = process.env.REACT_APP_WORKSPACE_ID ?? '';

// Id of the report to be embedded
export const reportId: string = process.env.REACT_APP_REPORT_ID ?? '';

export const appInsightsKey: string = process.env.REACT_APP_APP_INSIGHT_KEY ?? '';

export let environment: string = process.env.REACT_APP_ENVIRONMENT ?? '';

export let viewerUsers: string[] = [];

export let adminUsers: string[] = [];

export let croUsers: string[] = [];

export let customerSuccessUsers: string[] = [];

export let getUsersRole = async () => {
  if (environment === 'test') {
    return;
  }

  try {
    const response = await fetch(
      `https://prod-34.eastus.logic.azure.com:443/workflows/f3c29c836ae74d04bcc09be7a68cbfa7/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=9V1aY_YRxGN41qjxzf9a4F1gwAPRCyXBKzvJpjmN6Hs`
    );
    const data = await response.json();

    data.forEach((user: any) => {
      if (user.role_id === Role.ADMIN) {
        adminUsers.push(user.user_email);
      } else if (user.role_id === Role.VIEWER) {
        viewerUsers.push(user.user_email);
      } else if (user.role_id === Role.CRO) {
        croUsers.push(user.user_email);
      } else if (user.role_id === Role.CUSTOMER_SUCCESS) {
        customerSuccessUsers.push(user.user_email);
      }
    });
  } catch (error) {
    console.error('Error fetching users role:', error);
  }
};

// Used for mocking during testing
export let setEnvironment = (env: string) => {
  environment = env;
};
(window as any).setEnvironment = setEnvironment;

export let setRoleUsers = async (users: string[], role: Role) => {
  switch (role) {
    case Role.ADMIN:
      adminUsers = users;
      break;
    case Role.VIEWER:
      viewerUsers = users;
      break;
    case Role.CRO:
      croUsers = users;
      break;
    case Role.CUSTOMER_SUCCESS:
      customerSuccessUsers = users;
      break;
  }
};
(window as any).setRoleUsers = setRoleUsers;

// Used for mocking during testing
export let setViewerUsers = (users: string[]) => {
  viewerUsers = users;
};
(window as any).setViewerUsers = setViewerUsers;

export const setAdminUsers = (users: string[]) => {
  adminUsers = users;
};
(window as any).setAdminUsers = setAdminUsers;
